import apiClient from 'utilities/apiClient';

export const getWeeklyPlans = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.weeklyPlans}/${url}`, payload, true);
};

export const createWeeklyPlan = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.weeklyPlans}/create_weekly_plan`,
    payload,
    true
  );
};
export const updateWeeklyPlan = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.weeklyPlans}/create_weekly_plan`,
    payload,
    true
  );
};

export const forwardWeeklyPlan = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.weeklyPlans}/forward_weekly_plan`,
    payload,
    true
  );
};

export const updateStatus = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.weeklyPlans}/update_status`,
    payload,
    true
  );
};

export const deletePlan = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.weeklyPlans}/delete_weekly_plan`,
    payload,
    true
  );
};

export const updateExecutiveMembers = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.weeklyPlans}/update_executive`,
    payload,
    true
  );
};
